<template>
<iframe-template
  :src='widgetUrl'
  :width='widgetWidth'
  :visible='visible' >

  <template slot="iframe-toolbar" >
    <v-btn-toggle tile group
      color="deep-purple accent-3"
      v-model="darkmode" >

      <v-btn icon color='accent' :value='false' >
        <v-icon>mdi-weather-sunny</v-icon>
      </v-btn>
      <v-btn icon :value='true' >
        <v-icon>mdi-weather-night</v-icon>
      </v-btn>

    </v-btn-toggle>
  </template>

  <template slot="preferences" >
    <v-card-title class='py-1 grey lighten-4 overline' >
      Preview preferences
      <v-spacer/>
      <!-- <v-btn outlined small >Embed code</v-btn> -->
      <v-btn :href='widgetUrl' icon small class='ml-1' >
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-list dense >
      <v-list-item-group v-model="selectedItem" >
      <v-subheader >Space Booking Widget</v-subheader>
        <v-list-item :key='`s=${spaceId}`' :value='`s=${spaceId}`' >
          <v-list-item-content>
            <v-list-item-title v-text='space.title' />
          </v-list-item-content>
        </v-list-item>
        <template v-if='members && members.length > 0' >
          <v-subheader >Practitioner Booking Widgets</v-subheader>
          <v-list-item
            v-for='member in members'
            :key='`s=${member.id}`' :value='`p=${member.id}`' >
            <v-list-item-content>
              <v-list-item-title v-text='member.full_name' />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </template>
</iframe-template>
</template>
<script>
import IframeTemplate from '@/views/brand/digitalassets/IframeTemplate.vue'
import {mapGetters} from 'vuex'
import {DEFAULT_MOBILE_PHONE_WIDTH} from '@/store/constants.js'

export default {
  name: 'BookingWidget',
  components: {IframeTemplate},
  props: {
    value: { type: Object }
  },
  data () {
    return {
      selectedItem: null,
      darkmode: null,
      widgetWidth: DEFAULT_MOBILE_PHONE_WIDTH
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        this.selectedItem = 's=' + this.spaceId
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getMembers']),
    space () { return this.value },
    spaceId () { return this.getObjectPath(this.space, 'id') },
    members () { return this.getMembers(this.spaceId) },
    visible () {
      if (this.spaceId) { return true }
      return false
    },
    widgetUrl () {
      let url = 'https://book.appt.guru/?' + this.selectedItem
      if (this.darkmode === true) { url = url + '&dark=true' }
      if (this.darkmode === false) { url = url + '&dark=false' }
      return url
    }
  }
}
</script>
